'use client'

import {vars} from "@/assets/styles/_variables";
import {medias} from "@/assets/styles/_medias";
import {ThemeProvider as StyledThemeProvider} from "styled-components";

const ThemeProvider = ({children}) => {
    return (
        <StyledThemeProvider theme={{vars, medias}}>
            {children}
        </StyledThemeProvider>
    );
};

export default ThemeProvider;
